import React from 'react';
import styled from 'styled-components';
import { MaterialInputCustom } from './CurrencyInput';
import { CurrencyInputProps, StyleProps } from './types';
import { NumericFormat } from 'react-number-format';

const MaterialInputCustomFormula = styled(MaterialInputCustom).attrs<StyleProps>((props) => ({
  ...props,
  currencyPx: 14,
  style: {},
}))`
  max-width: 120px;
  .MuiInputBase-root {
    background-color: ${({ theme }) => theme.colors.white};
    padding-left: 8px;
  }

  input,
  textarea {
    font-size: 14px;
    padding: 6px 12px;
    padding-left: ${({ currency }) => (currency ? 0 : 12)}px !important;
    background-color: ${({ theme }) => theme.colors.white};
  }

  input::placeholder,
  textarea::placeholder {
    font-size: 14px;
  }
`;

export const CurrencyInputFormula = (props: CurrencyInputProps) => {
  // @ts-ignore
  return <NumericFormat customInput={MaterialInputCustomFormula} thousandSeparator="," {...props} />;
};
